<ng-container *ngIf="tenant">
    <button *ngIf="accessibleTenants.length > 1; else tenantLogoOnly" mat-button
        class="tenant-switcher-button" data-id="tenantSwitcher" [title]="tenant.name"
        [matMenuTriggerFor]="tenantMenu">
        <ng-container [ngTemplateOutlet]="tenantIdentity"></ng-container>
    </button>
    <ng-template #tenantLogoOnly>
        <span class="tenant-switcher-static" data-id="tenantSwitcher" [title]="tenant.name">
            <ng-container [ngTemplateOutlet]="tenantIdentity"></ng-container>
        </span>
    </ng-template>
    <ng-template #tenantIdentity>
        <img *ngIf="tenant.logoUrl" class="tenant-switcher-logo" [src]="tenant.logoUrl"
            [alt]="tenant.name" />
        <mat-icon *ngIf="!tenant.logoUrl" class="tenant-switcher-logo-icon">apartment</mat-icon>
    </ng-template>
    <mat-menu #tenantMenu="matMenu" xPosition="before" class="tenant-menu-panel">
        <button mat-menu-item *ngFor="let t of accessibleTenants"
            [attr.data-id]="'tenantOption-' + t.externalId" (click)="switchTenant$.emit(t)">
            <span class="tenant-option-row" [class.tenant-switcher-current]="t.externalId === tenant.externalId">
                <span class="tenant-option-logo-box">
                    <img *ngIf="t.logoUrl" class="tenant-option-logo" [src]="t.logoUrl" [alt]="t.name" />
                    <mat-icon *ngIf="!t.logoUrl" class="tenant-option-logo-icon">apartment</mat-icon>
                </span>
                <span class="tenant-option-name">{{ t.name }}</span>
            </span>
        </button>
    </mat-menu>
</ng-container>
